module.exports = __webpack_public_path__ + "img/blessing.df1e75a9.png";